export default __webpack_public_path__ + "static/media/ufo.f4c891bc.png";